import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
    iconId: {
        type: String,
        required: true,
    },
    type: {
        type: String,
        default: "s",
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass('fa' + __props.type + ' fa-' + __props.iconId)
  }, null, 2))
}
}

})